// Date range presets for dashboard filtering. Returns { start, end } as YYYY-MM-DD or null.
const iso = (d) => d.toISOString().slice(0, 10);

export const PRESETS = [
  { value: "all", label: "All time" },
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "60d", label: "Last 60 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "6m", label: "Last 6 months" },
  { value: "1y", label: "Last year" },
  { value: "fy", label: "This financial year" },
  { value: "lfy", label: "Last financial year" },
  { value: "custom", label: "Custom range" },
];

function financialYearStart(refYear) {
  // UK financial year: 1 April - 31 March
  return new Date(Date.UTC(refYear, 3, 1)); // month 3 = April
}

export function getRange(preset) {
  const now = new Date();
  const end = iso(now);
  const daysAgo = (n) => {
    const d = new Date(now);
    d.setDate(d.getDate() - n);
    return iso(d);
  };
  const monthsAgo = (n) => {
    const d = new Date(now);
    d.setMonth(d.getMonth() - n);
    return iso(d);
  };

  switch (preset) {
    case "all":
      return { start: null, end: null };
    case "7d":
      return { start: daysAgo(7), end };
    case "30d":
      return { start: daysAgo(30), end };
    case "60d":
      return { start: daysAgo(60), end };
    case "90d":
      return { start: daysAgo(90), end };
    case "6m":
      return { start: monthsAgo(6), end };
    case "1y":
      return { start: monthsAgo(12), end };
    case "fy": {
      const y = now.getUTCMonth() >= 3 ? now.getUTCFullYear() : now.getUTCFullYear() - 1;
      const s = financialYearStart(y);
      const e = new Date(Date.UTC(y + 1, 2, 31));
      return { start: iso(s), end: iso(e) };
    }
    case "lfy": {
      const y = now.getUTCMonth() >= 3 ? now.getUTCFullYear() - 1 : now.getUTCFullYear() - 2;
      const s = financialYearStart(y);
      const e = new Date(Date.UTC(y + 1, 2, 31));
      return { start: iso(s), end: iso(e) };
    }
    default:
      return { start: null, end: null };
  }
}
